module.exports = __webpack_public_path__ + "img/value-blocks-slider-honda.bf03d885.png";